import * as ActionTypes from './types';

export function deletePillar(payload) {
    return {
        type: ActionTypes.DELETE_PILLAR,
        payload: payload
    }
}

export function deletePillarSuccess(payload) {
  return {
    type: ActionTypes.DELETE_PILLAR_SUCCESS,
    payload: payload
  }
}

export function deletePillarFailed(payload) {
  return {
    type: ActionTypes.DELETE_PILLAR_FAILED,
    payload: payload
  }
}

export function changePillarState(payload) {
    return {
        type: ActionTypes.CHANGE_PILLAR_STATE,
        payload: payload
    }
}

export function updatePillar(payload) {
  return {
    type: ActionTypes.UPDATE_PILLAR,
    payload: payload
  }
}

export function updatePillarSuccess(payload) {
  return {
    type: ActionTypes.UPDATE_PILLAR_SUCCESS,
    payload: payload
  }
}

export function updatePillarFailed(payload) {
  return {
    type: ActionTypes.UPDATE_PILLAR_FAILED,
    payload: payload
  }
}

export function getPillarById(payload) {
  return {
    type: ActionTypes.GET_PILLAR_BY_ID,
    payload: payload
  }
}

export function getPillarByIdSuccess(payload) {
  return {
    type: ActionTypes.GET_PILLAR_BY_ID_SUCCESS,
    payload: payload
  }
}

export function getPillarByIdFailed(payload) {
  return {
    type: ActionTypes.GET_PILLAR_BY_ID_FAILED,
    payload: payload
  }
}

export function createPillar(payload) {
  return {
    type: ActionTypes.CREATE_PILLAR,
    payload: payload
  }
}

export function createPillarSuccess(payload) {
  return {
    type: ActionTypes.CREATE_PILLAR_SUCCESS,
    payload: payload
  }
}

export function createPillarFailed(payload) {
  return {
    type: ActionTypes.CREATE_PILLAR_FAILED,
    payload: payload
  }
}



// WEBPACK FOOTER //
// ./src/actions/pillar.js